import { FC } from 'react';
import {
  IEnhancedField,
  onEnhanceClickHandler,
  isProductEnhancerField,
  onReEnhanceClickHandler,
  onTextAreaChangeHandler,
  onTagRemoveClickHandler,
  onLabelValueChangeHandler
} from '../../types';
import { ENHANCED_FIELD_TO_COMPONENT } from './config';
import { EnhancedCardContainer } from './styled';
import { EnhancedCardHeader, EnhancedEmptyState } from './components';
import { EnhancedCardLoading } from '../enhanced-card-loading';

interface EnhancedFieldCardProps {
  isLoading: boolean;
  field: IEnhancedField;
  onEnhanceClick: onEnhanceClickHandler;
  onReEnhanceClick: onReEnhanceClickHandler;
  onTagRemoveClick: onTagRemoveClickHandler;
  onTextAreaChange: onTextAreaChangeHandler;
  onLabelValueChange: onLabelValueChangeHandler;
}

export const EnhancedFieldCard: FC<EnhancedFieldCardProps> = ({
  field,
  isLoading,
  onEnhanceClick,
  onReEnhanceClick,
  onTagRemoveClick,
  onTextAreaChange,
  onLabelValueChange
}) => {
  // field does not have state from backend yet, show "enhance" button
  if (!isProductEnhancerField(field))
    return (
      <EnhancedCardContainer>
        <EnhancedCardHeader
          isEmpty
          title={field.title}
          disableReEnhance={isLoading}
        />
        <EnhancedEmptyState onEnhanceClick={() => onEnhanceClick(field.id)} />
      </EnhancedCardContainer>
    );

  const FieldComponent = ENHANCED_FIELD_TO_COMPONENT[field.type];

  return (
    <EnhancedCardContainer>
      <EnhancedCardHeader
        title={field.title}
        disableReEnhance={isLoading}
        onReEnhanceClick={() => onReEnhanceClick(field.id)}
      />
      {isLoading && <EnhancedCardLoading />}

      {!isLoading && (
        <FieldComponent
          field={field}
          onTagRemoveClick={onTagRemoveClick}
          onTextAreaChange={onTextAreaChange}
          onLabelValueChange={onLabelValueChange}
        />
      )}
    </EnhancedCardContainer>
  );
};
